export default __webpack_public_path__ + "static/media/tictactoe.2157b428.png";